import { render, staticRenderFns } from "./HoverIcon.vue?vue&type=template&id=55fec634&"
import script from "./HoverIcon.vue?vue&type=script&lang=js&"
export * from "./HoverIcon.vue?vue&type=script&lang=js&"
import style0 from "./HoverIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports